module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAARVBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADZo62CAAAAF3RSTlMAZapVDdjiBf283IlbOCPBIkCVUkTzKFRU1+IAAACeSURBVHjabZBJDsQgDASb1RgIScjy/6eOQloRh/EBihIIuzFKnI3pCtYJvjqymibSjOaDSkrYwdpDkQFl9c+2jNWv5dlcGKctZQwbHCBxwSyxREFV4LWeoBXWkM0JgkVs5NwJLSIJOSlBEi7/R4Z7lnxuzSz5UdVJsiU2T8nmOSYlx/wC8ec5BQLpc3RdppA38bfR7PCVVBtTira+135qHAVmvsG8ewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_gth.png
// module id = mOYt
// module chunks = 1